exports.Routes = {
  Page404: (query) => ({ pathname: "/404", query }),
  AccountPage: (query) => ({ pathname: "/account/[accountId]", query }),
  ContactPage: (query) => ({ pathname: "/account/contact/[contactId]", query }),
  ShowOrganizationPage: (query) => ({ pathname: "/admin/organizations/[organizationId]", query }),
  EditOrganizationPage: (query) => ({ pathname: "/admin/organizations/[organizationId]/edit", query }),
  OrganizationsPage: (query) => ({ pathname: "/admin/organizations", query }),
  NewOrganizationPage: (query) => ({ pathname: "/admin/organizations/new", query }),
  ShowSubscriptionPage: (query) => ({ pathname: "/admin/subscriptions/[subscriptionId]", query }),
  EditSubscriptionPage: (query) => ({ pathname: "/admin/subscriptions/[subscriptionId]/edit", query }),
  SubscriptionsPage: (query) => ({ pathname: "/admin/subscriptions", query }),
  NewSubscriptionPage: (query) => ({ pathname: "/admin/subscriptions/new", query }),
  ShowUserPage: (query) => ({ pathname: "/admin/users/[userId]", query }),
  EditUserPage: (query) => ({ pathname: "/admin/users/[userId]/edit", query }),
  UsersPage: (query) => ({ pathname: "/admin/users", query }),
  NewUserPage: (query) => ({ pathname: "/admin/users/new", query }),
  ChatPage: (query) => ({ pathname: "/chat", query }),
  DPAPage: (query) => ({ pathname: "/dpa", query }),
  InboxPage: (query) => ({ pathname: "/inbox", query }),
  HomePage: (query) => ({ pathname: "/", query }),
  AllInsightsPage: (query) => ({ pathname: "/insights", query }),
  InviteProblemPage: (query) => ({ pathname: "/invite-problem", query }),
  InviteLinkPage: (query) => ({ pathname: "/invite/[inviteSlug]", query }),
  WeeklySummaryUnsubscribeConfirmedPage: (query) => ({ pathname: "/lists/unsubscribe/weekly-summary-confirmed", query }),
  WeeklySummaryUnsubscribeErrorPage: (query) => ({ pathname: "/lists/unsubscribe/weekly-summary-error", query }),
  LoginPage: (query) => ({ pathname: "/login", query }),
  EditOrganizationConfigPage: (query) => ({ pathname: "/organization-configs/[organizationConfigId]/edit", query }),
  PrivacyPolicyPage: (query) => ({ pathname: "/privacy-policy", query }),
  ProductResearchAddSourcePage: (query) => ({ pathname: "/product-research/add-source", query }),
  ProductResearchUserFeedbackChatPage: (query) => ({ pathname: "/product-research/chat/[chatId]", query }),
  ProductResearchCompetitiveAnalysisPage: (query) => ({ pathname: "/product-research/competitive-analysis", query }),
  OnboardingPage: (query) => ({ pathname: "/product-research/onboarding", query }),
  ProductResearchRatingsReviewsPage: (query) => ({ pathname: "/product-research/ratings-reviews", query }),
  ConnectGooglePlayAppSourcePage: (query) => ({ pathname: "/product-research/sources/connect/app-google-play", query }),
  ConnectIosAppSourcePage: (query) => ({ pathname: "/product-research/sources/connect/app-ios", query }),
  ConnectZapierPage: (query) => ({ pathname: "/product-research/sources/connect/zapier/[type]", query }),
  AnalysisPage: (query) => ({ pathname: "/product-research/user-feedback/[[...params]]", query }),
  ProjectPage: (query) => ({ pathname: "/projects/[projectId]", query }),
  ProjectsPage: (query) => ({ pathname: "/projects", query }),
  RatingsReviewsPage: (query) => ({ pathname: "/ratings-reviews", query }),
  DemoRatingsReviewsPage: (query) => ({ pathname: "/ratings-reviews/demo/ratings-reviews", query }),
  RepositoryPage: (query) => ({ pathname: "/repository", query }),
  ResetPasswordPage: (query) => ({ pathname: "/reset-password", query }),
  SecurityPage: (query) => ({ pathname: "/security", query }),
  SetPasswordPage: (query) => ({ pathname: "/set-password", query }),
  AccountUsagePage: (query) => ({ pathname: "/settings/account/usage", query }),
  CheckoutCancelledPage: (query) => ({ pathname: "/settings/billing/checkout/cancel", query }),
  CheckoutSuccessPage: (query) => ({ pathname: "/settings/billing/checkout/success", query }),
  ManageBillingPlanPage: (query) => ({ pathname: "/settings/billing/manage-plan", query }),
  BillingPortalPage: (query) => ({ pathname: "/settings/billing/portal", query }),
  SlackNotificationsPage: (query) => ({ pathname: "/settings/notifications/slack", query }),
  SignupConfirmationErrorPage: (query) => ({ pathname: "/signup-confirmation-error", query }),
  SignupConfirmationPage: (query) => ({ pathname: "/signup-confirmation", query }),
  SignupConfirmedPage: (query) => ({ pathname: "/signup-confirmed", query }),
  SignupContactDetailsPage: (query) => ({ pathname: "/signup-contact-details", query }),
  SignupProblemPage: (query) => ({ pathname: "/signup-problem", query }),
  SignupRecaptchaPage: (query) => ({ pathname: "/signup-recaptcha", query }),
  SignupPage: (query) => ({ pathname: "/signup", query }),
  SubprocessorsPage: (query) => ({ pathname: "/subprocessors", query }),
  PublicSurveyPage: (query) => ({ pathname: "/surveys-public/[urlSlug]", query }),
  SurveyPage: (query) => ({ pathname: "/surveys/[surveyId]", query }),
  SurveysPage: (query) => ({ pathname: "/surveys", query }),
  IntegrationsPage: (query) => ({ pathname: "/team/integrations", query }),
  ManageIntegration: (query) => ({ pathname: "/team/integrations/[type]", query }),
  ReportCardPage: (query) => ({ pathname: "/team/report-card", query }),
  TermsAndConditionsPage: (query) => ({ pathname: "/terms-and-conditions", query }),
  DashboardPage: (query) => ({ pathname: "/trends", query })
}